<template>
  <div class="cardCover">
    <amp-img :src="cardImgSrc" :alt="ndoeTitle" height="1118" width="750" layout="responsive"></amp-img>
  </div>
</template>

<script>
  import get from 'lodash/get'
  import { getImageByType } from 'mixins/utilities'

  export default {
    name: 'amp-card-cover',
    props: [
      'node',
    ],
    computed: {
      ndoeTitle() {
        return get(this.node, 'title', 'Abacus')
      },
      cardImgSrc() {
        const image = getImageByType(get(this.node, 'images', []), 'card_mobile')
        return get(image, 'full', '/image/placeholder/32/40/5A9CB5/20')
      },
    },
  }
</script>


// WEBPACK FOOTER //
// AmpCardCover.vue?5fbd0d3a